/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import { useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
// import { GET_ALL_COURSE_TAGS } from '../../shared/QueryList';
import GET_ALL_COURSE_TAGS from '../../../gql/queries/get-all-courses-tags.gql';

function Tags({
  organizationId, typeTags, handleTagsCourse, centerChange, initialTagsData: data,
}) {
  const [selectedTag, setSelectedTag] = useState({
    online: 'all',
    offline: 'all',
  });

  const handleClickTags = (tagId, type) => {
    if (selectedTag[type] === tagId) return; // Prevent redundant updates
    setSelectedTag((prev) => ({
      ...prev,
      [type]: tagId,
    }));
    console.log('Selected Tag:', tagId);
    handleTagsCourse(type, tagId);
  };

  if (!data) {
    return <p>No Tags Found.</p>;
  }

  // if (!data?.getOrganizationById?.tags?.length) {
  //   return <p>No tags available.</p>;
  // }

  const getButtonClass = (id) => `tab-btn px-4 py-2 border-2 uppercase px-8 text-sm font-normal text-gray-700 rounded-full cursor-pointer whitespace-nowrap ${
    selectedTag[typeTags] === id ? 'text-white bg-sky-900' : 'bg-white border-[#B9BFC1]'
  }`;

  return (
    <div className="flex space-x-2">
      <button
        onClick={() => handleClickTags('all', typeTags)}
        aria-pressed={selectedTag[typeTags] === 'all'}
        aria-label="Select all tags"
        className={getButtonClass('all')}
      >
        All
      </button>
      {data?.getOrganizationById?.tags?.map((item) => (
        <button
          onClick={() => handleClickTags(item.id, typeTags)}
          key={item.id}
          aria-pressed={selectedTag[typeTags] === item.id}
          aria-label={`Select ${item.name} tag`}
          className={getButtonClass(item.id)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
}

export default Tags;
